// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// Components
import { FormElems } from '../../components';

const DraftAction = ({ data, actionType, history }) => {
    const handleDraftClick = actionType => {
        history.push(`/mob/draft`);
    };

    return (
        <div className="userAction draft-action" id="draft-action">
            <FormElems.Button
                buttonType="secondary"
                text="Draft"
                type="button"
                handleClick={handleDraftClick}
            />
        </div>
    );
};

DraftAction.propTypes = {
    actionType: PropTypes.string,
    data: PropTypes.object.isRequired,
    history: PropTypes.object,
};

export default withRouter(DraftAction);
